import React, { useEffect, useRef, useState } from 'react';
import { MessageSquareText, ShieldCheck } from 'lucide-react';
import { OwnerButton, OwnerShell } from '../OwnerShell';
import { TextField } from '../OwnerFields';
import { ownerProfile } from '../../../data/ownerProfile';
import { fromBn, toBn } from '../../../utils/bn';
import type { OwnerNav } from '../../../types/owner';
export function OwnerOtp({
  nav
}: {
  nav: OwnerNav;
}) {
  const [digits, setDigits] = useState<string[]>(Array(6).fill(''));
  const [error, setError] = useState('');
  const [seconds, setSeconds] = useState(59);
  const [verified, setVerified] = useState(false);
  const [pass, setPass] = useState({
    a: '',
    b: ''
  });
  const refs = useRef<(HTMLInputElement | null)[]>([]);
  useEffect(() => {
    if (seconds <= 0) return;
    const t = window.setTimeout(() => setSeconds(s => s - 1), 1000);
    return () => window.clearTimeout(t);
  }, [seconds]);
  const setAt = (i: number, v: string) => {
    const d = fromBn(v).replace(/\D/g, '').slice(-1);
    setDigits(ds => ds.map((x, n) => n === i ? d : x));
    setError('');
    if (d && i < 5) refs.current[i + 1]?.focus();
  };
  const verify = () => {
    const code = digits.join('');
    if (code.length < 6) return setError('৬ সংখ্যার কোড লিখুন');
    if (code !== '123456') return setError('ভুল কোড। অনুগ্রহ করে আবার চেষ্টা করুন।');
    if (nav.otpPurpose === 'register') {
      nav.showToast('মোবাইল নম্বর যাচাই সম্পন্ন');
      nav.reset('home');
      nav.go('profileForm');
    } else if (nav.otpPurpose === 'login') {
      nav.showToast('লগইন সফল');
      nav.reset('home');
    } else setVerified(true);
  };
  const savePass = () => {
    if (pass.a.length < 8 || pass.a !== pass.b) return setError('পাসওয়ার্ড কমপক্ষে ৮ অক্ষর এবং দুটি ঘর একই হতে হবে');
    nav.showToast('নতুন পাসওয়ার্ড সেট হয়েছে — লগইন করুন');
    nav.reset('login');
  };
  return <OwnerShell nav={nav} title={nav.otpPurpose === 'reset' ? 'পাসওয়ার্ড পুনরুদ্ধার' : 'মোবাইল নম্বর যাচাই'} bodyClassName="px-5 py-6" data-id="element-1805" data-mp="1ucyps6045dce">
      {!verified ? <>
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-navy-50 text-navy-800" data-id="element-1806" data-mp="3rbqdjbdv091c"><MessageSquareText className="h-8 w-8" data-id="element-1807" data-mp="410i60h7rby8" /></span>
          <p className="mt-4 text-center text-[15px] leading-relaxed text-slate-700" data-id="element-1808" data-mp="42lf1wr036z9">
            <b className="text-navy-900" data-id="element-1809" data-mp="3vewj0gt5dw6r">{ownerProfile.mobileMasked}</b> নম্বরে একটি যাচাইকরণ কোড পাঠানো হয়েছে।
          </p>
          <div className="mt-6 flex justify-center gap-2" role="group" aria-label="৬ সংখ্যার OTP" data-id="element-1810" data-mp="dxddt3wbjzvm">
            {digits.map((d, i) => <input key={i} ref={el => refs.current[i] = el} value={d ? toBn(d) : ''} onChange={e => setAt(i, e.target.value)} onKeyDown={e => e.key === 'Backspace' && !digits[i] && i > 0 && refs.current[i - 1]?.focus()} inputMode="numeric" aria-label={`OTP সংখ্যা ${i + 1}`} className={`h-14 w-11 rounded-lg border-2 text-center font-heading text-2xl font-bold text-navy-900 outline-none focus:border-navy-700 ${error ? 'border-red-400' : 'border-slate-300'}`} data-id="element-1811" data-mp="mzmk1hkk1737" data-mpi={i} />)}
          </div>
          {error && <p className="mt-3 text-center text-xs font-medium text-red-600" data-id="element-1812" data-mp="20vnx3s38z0nn">{error}</p>}
          <button onClick={() => setDigits('123456'.split(''))} className="mx-auto mt-4 block rounded-full bg-amber-50 px-3 py-1 text-[11px] font-medium text-amber-800" data-id="element-1813" data-mp="25tpor1eqo8aq">
            প্রোটোটাইপ OTP: ১২৩৪৫৬ — ট্যাপ করে বসান
          </button>
          <OwnerButton className="mt-6" onClick={verify} data-id="element-1814" data-mp="1hx1v8azwp5io">যাচাই করুন</OwnerButton>
          <p className="mt-4 text-center text-sm text-slate-500" data-id="element-1815" data-mp="1hz4w5q2lkj26">
            কোড পাননি?{' '}
            {seconds > 0 ? <span data-id="element-1816" data-mp="3cb32nk9iv0ud">০০:{toBn(String(seconds).padStart(2, '0'))} পর আবার পাঠানো যাবে</span> : <button onClick={() => {
          setSeconds(59);
          nav.showToast('নতুন OTP পাঠানো হয়েছে');
        }} className="font-semibold text-navy-700" data-id="element-1817" data-mp="3h9wb2y9yc1no">পুনরায় OTP পাঠান</button>}
          </p>
        </> : <div className="space-y-4" data-id="element-1818" data-mp="1c8k2a7xmqp57">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-50 text-emerald-700" data-id="element-1819" data-mp="1c9msser1ipkl"><ShieldCheck className="h-8 w-8" data-id="element-1820" data-mp="17btojr9as5my" /></span>
          <p className="text-center text-sm text-slate-600" data-id="element-1821" data-mp="138wzbhp95ba1">মোবাইল যাচাই সম্পন্ন। নতুন পাসওয়ার্ড নির্ধারণ করুন।</p>
          <TextField id="np-a" label="নতুন পাসওয়ার্ড" type="password" value={pass.a} onChange={v => setPass(p => ({
        ...p,
        a: v
      }))} required data-id="element-1822" data-mp="y9u74xudezjh" />
          <TextField id="np-b" label="পাসওয়ার্ড নিশ্চিত করুন" type="password" value={pass.b} onChange={v => setPass(p => ({
        ...p,
        b: v
      }))} required error={error} data-id="element-1823" data-mp="oj8ysiowagnd" />
          <OwnerButton variant="green" onClick={savePass} data-id="element-1824" data-mp="jlzcvd0psn4a">পাসওয়ার্ড সংরক্ষণ করুন</OwnerButton>
        </div>}
    </OwnerShell>;
}